import React, { useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import StatsCard from './StatsCard';
import '../../styles/dashboard/DashboardStats.css';

function DashboardStats() {
  const [stats, setStats] = useState({
    total_replies: 0,
    total_tweets: 0,
    total_bots: 0,
    bot_percentage: 0
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://api.anti-bot.ai/api/dashboard-stats')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStats({
            total_replies: data.total_replies,
            total_tweets: data.total_tweets,
            total_bots: data.total_bots,
            bot_percentage: data.bot_percentage
          });
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));

    const socket = io('https://api.anti-bot.ai', {
      transports: ['polling', 'websocket']
    });

    socket.on('dashboard_stats_update', (data) => {
      setStats({
        total_replies: data.total_replies,
        total_tweets: data.total_tweets,
        total_bots: data.total_bots,
        bot_percentage: data.bot_percentage
      });
    });

    return () => socket.close();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-stats-loading">
        <div className="spinner"></div>
        <p>טוען סטטיסטיקות...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-stats">
      <StatsCard
        title="תגובות"
        value={stats.total_replies}
        subtitle="שנותחו"
        color="#D89B5A"
        iconImg="/image/Cards/Comments.png"
      />
      <StatsCard
        title="פוסטים"
        value={stats.total_tweets}
        subtitle="שנבדקו"
        color="#D89B5A"
        iconImg="/image/Cards/Posts.png"
      />
      <StatsCard
        title="בוטים"
        value={stats.total_bots}
        subtitle="שזוהו"
        color="#D89B5A"
        iconImg="/image/Cards/Bots.png"
      />
      <StatsCard
        title="אחוז בוטים"
        value={stats.bot_percentage}
        decimals={2}
        suffix="%"
        subtitle="מתוך התגובות"
        color="#D89B5A"
        iconImg="/image/Cards/Percentage.png"
      />
    </div>
  );
}

export default DashboardStats;